import { useLanguageContext } from 'context/LanguageProvider';
import { useEffect, useState } from 'react';
import { isValidLocaleValue, LOCALES } from 'utils/languageUtils';

const useLanguage = () => {
  const { language } = useLanguageContext();

  const [value, setValue] = useState(
    isValidLocaleValue(language) ? (language === LOCALES.ENGLISH ? 'en' : 'gr') : 'gr'
  );

  useEffect(() => {
    setValue(isValidLocaleValue(language) ? (language === LOCALES.ENGLISH ? 'en' : 'gr') : 'gr');
  }, [language]);

  return value;
};
export default useLanguage;
